module.exports = __webpack_public_path__ + "img/homonym.fba889e6.png";